import { createStyles, makeStyles } from '@forgeglobal/design-framework';
interface CSSProps {
  secondaryLine?: boolean;
}
export const useStyles = makeStyles((theme) =>
  createStyles({
    wrapper: {
      width: '100%',
    },
    // desktop table styles
    table: {
      width: '100%',
      border: `1px solid ${theme.palette.divider}`,
      background: theme.palette.background.paper,
      borderCollapse: 'collapse',
      '& th': {
        padding: '14px 8px',
        fontFamily: 'Roboto, sans-serif',
        fontSize: 14,
        lineHeight: '20px',
        color: theme.palette.text.secondary,
        textTransform: 'initial',
        letterSpacing: 0,
        fontWeight: 400,
        whiteSpace: 'nowrap',
        textAlign: 'start',
        '&:first-child': {
          paddingLeft: theme.spacing(4),
        },
        '&:last-child': {
          paddingRight: theme.spacing(4),
        },
      },
      '& tr': {
        border: `1px solid ${theme.palette.divider}`,
      },
      '& tbody': {
        '& tr': {
          '&:hover': {
            background: '#EDF8FB',
          },
        },
        '& td': {
          maxWidth: 0,
          '&:first-child': {
            paddingLeft: theme.spacing(3),
          },
          '&:last-child': {
            paddingRight: theme.spacing(3),
          },
        },
      },
    },
    tableExpand: {
      width: theme.spacing(4),
    },
    clickable: {
      cursor: 'pointer',
    },
    // mobile table styles
    cardTable: {
      width: '100%',
      border: `1px solid ${theme.palette.divider}`,
      background: theme.palette.background.paper,
    },
    cardTableName: {
      color: theme.palette.text.secondary,
      padding: theme.spacing(1.75, 3),
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    cardRowWrapper: {
      display: 'flex',
      borderBottom: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(0, 3),
      '&:hover': {
        background: '#EDF8FB',
      },
    },
    cardRow: {
      flexGrow: 1,
      padding: theme.spacing(2),
      '&:last-child': {
        borderBottom: 'none',
      },
    },
    cardCell: {
      paddingBottom: theme.spacing(1),
      '&:last-child': {
        paddingBottom: 0,
      },
    },
    cardTitle: {
      color: theme.palette.text.secondary,
      marginBottom: 2,
    },
    cardValue: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    cardExpand: {
      width: theme.spacing(3),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    alternateContentBlock: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      padding: theme.spacing(7, 3, 8),
      background: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      [theme.breakpoints.up('md')]: {
        borderTop: 'none',
      },
    },

    // cell styles
    baseHeader: {
      [theme.breakpoints.down('md')]: {
        fontSize: '14px',
        letterSpacing: '0.25px',
        lineHeight: '1.43',
      },
    },
    baseCell: {
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(2, 1),
        lineHeight: 1,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
    },
    titleCell: {
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(1),
        fontWeight: 700,
        fontSize: '16px',
        letterSpacing: '0.25px',
        lineHeight: '1.43',
      },
    },
    titleCellHeader: {
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    clickableCell: {
      cursor: 'pointer',
    },
    colorCell: {
      position: 'relative',
      height: 68,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.down('md')]: {
        height: '100%',
      },
    },
    colorMain: {
      width: theme.spacing(1),
      height: theme.spacing(4.5),
      [theme.breakpoints.down('md')]: {
        height: 'calc(100% - 36px)',
      },
    },
    colorExpanded: {
      position: 'absolute',
      bottom: -1,
      width: 2,
      height: '50%',
    },
    colorSecondary: {
      position: 'absolute',
      width: 2,
      height: 'calc(100% + 4px)',
      [theme.breakpoints.down('md')]: {
        marginLeft: 8,
      },
    },
    rightAlign: {
      [theme.breakpoints.up('md')]: {
        textAlign: 'end',
      },
    },
    alignNumbers: {
      fontVariantNumeric: 'tabular-nums',
    },
    debit: {
      color: theme.palette.error.main,
    },

    twoLine: ({ secondaryLine }: CSSProps) => ({
      [theme.breakpoints.up('md')]: {
        marginTop: secondaryLine ? '-7px' : 0,
        marginBottom: secondaryLine ? '-7px' : 0,
      },
    }),
    cellText: {
      [theme.breakpoints.up('md')]: {
        overflow: 'inherit',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
    },

    highlighted: {
      fontWeight: 700,
    },
    onlyMobile: {
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    onlyDesktop: {
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    downloadIcon: {
      verticalAlign: 'text-bottom',
      marginLeft: 16,
      width: theme.spacing(2),
      height: theme.spacing(2),
    },
    downloadLink: {
      alignContent: 'center',
      cursor: 'pointer',
    },
    headerCell: {
      display: 'flex',
    },
    error: {
      color: 'red',
    },
    sortIcon: {
      marginLeft: '4px',
    },
  })
);
